export const BOT_LEVELS = ['medium', 'hard'];
export function isBotLevel(value) {
    return value === 'medium' || value === 'hard';
}
/** A strategy id is `${gameId}/${level}` by convention (roomReducer). */
export function botLevelOf(strategyId) {
    return strategyId.endsWith('/hard') ? 'hard' : 'medium';
}
export function rematchStanding(room, seat) {
    const occ = room.seats[seat];
    if (!occ || occ.kind === 'empty')
        return 'left';
    if (occ.kind === 'bot')
        return 'in';
    if (hasLeftTable(room, occ.userId))
        return 'left';
    const choice = room.rematchChoices?.find((c) => c.userId === occ.userId);
    if (!choice)
        return 'undecided';
    return choice.in ? 'in' : 'out';
}
/** Can the same seats play again? Only when every seat is still filled and
 *  every player at the table has said they are in. */
export function everyoneInForRematch(room) {
    return room.seats.every((_, seat) => rematchStanding(room, seat) === 'in');
}
/** Did this player walk away from the match, rather than drop off it? */
export function hasLeftTable(room, userId) {
    return room.leftUserIds?.includes(userId) ?? false;
}
/** Idle seats can be voted out even while connected — this is what stops a
 *  present-but-absent player stalling a table, given there are no turn clocks. */
export const IDLE_REPLACE_MS = 3 * 60 * 1000;
export const DISCONNECT_GRACE_MS = 45 * 1000;
export const TABLE_TTL_SECONDS = 60 * 60;
//# sourceMappingURL=room.js.map